var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoiBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 964,
    viewBox: "0 0 1440 964",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-58.9627 456.999H1040V767.407L-65 963.999L-58.9627 456.999Z",
    fill: "#C4DCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1498.96 640L400 640L400 248.163L1505 0.00012207L1498.96 640Z",
    fill: "#C4DBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-31.6952 356.489H1480V706.288L-40 927.828L-31.6952 356.489Z",
    fill: "#4C94FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1449.7 619.339L-62 619.339L-62 269.539L1458 47.9996L1449.7 619.339Z",
    fill: "#4C94FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoiBackground);
export default __webpack_public_path__ + "static/media/roi-background.4e1fa92da7ae63e2737198b29548ab69.svg";
export { ForwardRef as ReactComponent };